module.exports = __webpack_public_path__ + "static/media/sr2.1c9aca14.png";